import { request } from '@blade/common';
/**
 *@Description: 任务详情
 */
export const queryDeviceRtspPreviewAddress = (deviceId) => request({
    url: `/api/camera-device-management/api/v1/devices/${deviceId}/rtsp_preview_address`,
    method: 'GET',
});
export const getTaskDetail = (id) => request({
    url: `/api/task-management/api/v1/task/${id}`,
    method: 'GET',
});
export const updateTask = (data) => request({
    url: '/api/task-management/api/v1/task/updateTask',
    method: 'PUT',
    data,
});
export const postTask = (data) => request.post('/api/task-management/api/v1/task/createTask', data);
/**
 *@Description: 根据设备查询区域
 */
export const getDeviceRegion = (deviceId) => request({
    url: `/api/map-management/api/v1/map/device/${deviceId}`,
    method: 'GET',
});
/**
 *@Description: 获取设备
 */
export const getDeviceTree = () => request.post(`/api/camera-device-management/api/v1/device-groups/devices/tree`, {});
/**
 *@Description: 批量通过设备ID查询区域id
 */
export const getQueryDeviceDetail = (data) => request.post(`/api/map-management/api/v1/map/device/query/batch/device/detail`, data);
export const getAllPortarit = () => {
    return request.post('/api/portrait-management/api/v1/portraitlib/list', {});
};
/**
 *@Description: 批量通过设备ID查询区域id
 */
export const queryDeviceTaskErrorConfigs = (taskId) => {
    return request.get(`/api/task-management/api/v1/task/devices/errorMsg/${taskId}`);
};
/**
 *@deviceIds: 批量通过设备ID查询人体
 */
export const getQueryLablePerson = (data) => {
    return request.post(`/api/task-management/api/v1/task/device/lablePerson/deviceIds`, data);
};
/**
 *@deviceIds: 新增人像库
 */
export const getPortraitlib = (data) => {
    return request.post(`/api/portrait-management/api/v1/portraitlib/add`, data);
};
